module.exports = __webpack_public_path__ + "img/logo-bs.7609ce8e.png";